import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-17a0123e"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("link", {
  rel: "stylesheet",
  href: "https://lf-cdn-tos.bytescm.com/obj/static/livesaas-client/pc/css/index.1.3.21.css"
}, null, -1))
const _hoisted_2 = { style: {'font-size': '10px', margin: 0,'background-color': '#080B12', height: '100vh', background: 'white'} }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"content\" data-v-17a0123e><div class=\"menu-top\" data-v-17a0123e><div id=\"player\" class=\"player\" data-v-17a0123e></div><div id=\"menu\" class=\"menu\" data-v-17a0123e></div></div><div id=\"menu2\" class=\"menu-bottom\" data-v-17a0123e></div></div>", 1)

import { onMounted, onUnmounted, ref, computed } from 'vue'
import { requestVideoGetActivityById, requestVideoGetToken, ENUM_ACTIVITY_MODE, requestVideoReserve } from '@/apis/live'
import { reserize } from '@/plugins/utils'
import { useSite2Station, useUser, isJA } from '@/store'
import { getLiveDetailPageHref, showIfNeedMemberDialogForLive } from '@/components/LiveCardBox/LiveCard/utils'
import { useRoute } from 'vue-router'
import { Site } from '@/common/const'
import { ElMessage } from 'element-plus'
import { t } from '@/plugins/i18n'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const importSheet = computed(() => useRoute().name === 'live')

const router = useUser()
const showIfNeedMemberDialogForLiveOptions = {
  onOK: () => {
    const user = useUser()
    const isD2C = user.systemSource === 1
    window.location.href = `/${isD2C ? 'd2c' : 'b2b'}/vip/VipLevel`
    // router.push({
    //   path: `/${isD2C}/vip/VipLevel`
    // })
    // router.push(useRtfix(`/${isD2C}/vip/VipLevel`))
  }
}
const resActivityDetail = ref<any>({
  pcBackImageUrl: ''
})

const webSDK: { current: any } = { current: null }

onUnmounted(() => {
  webSDK.current?.destroy()
})
const initLive = () => {
  if (webSDK) {
    webSDK.current?.destroy()
  }
  const _window: any = window
  const ByteLiveWebSDK = _window.ByteLiveWebSDK
  // debugger
  webSDK.current = new ByteLiveWebSDK({
    activityId: resActivityDetail.value.activityId,
    token: resActivityDetail.value.token,
    service: 'testDemo',
    mode: 2,
    modules: [
      {
        // 接入方页面内的元素ID, 对应模块会嵌入到此元素内
        id: 'player',
        mode: 'player'
      },
      {
        id: 'menu',
        mode: 'menu',
        // 配置需要显示的菜单，如需全部显示则无需配置
        menu: ['comment', 'imagetext', 'cardlist']
      },
      {
        id: 'menu2',
        mode: 'menu',
        menu: ['bandcontent']
      }
    ],
    options: {
      ...resActivityDetail.value.reserveFlag === 0 ? {} : { isReserved: true },
      pcPlayerHeader: true,
      disableCardRedirect: true,
      videoFillMode: 'cover'
    }
  })
  const domObserver = new MutationObserver((_mutationList, observer) => {
    // 外层的盒子
    const countdownBoxDom = window.document.querySelector('.bytelive-PlayerComponent-countdownBox')
    // 预约按钮
    const reservationBtnDom = window.document.querySelector('.bytelive-PlayerComponent-reservationBt')
    if (!countdownBoxDom) return
    if (reservationBtnDom) {
      reservationBtnDom.addEventListener('click', async () => {
        const res = await requestVideoReserve({ activityId: resActivityDetail.value.activityId })
        if (res.success) {
          resActivityDetail.value.reserveFlag = 1
          initLive()
        }
      })
    }
    observer.disconnect()
    domObserver.disconnect()
  })
  // debugger
  domObserver.observe(document.body, { childList: true, subtree: true })
}
onMounted(async () => {
  window.localStorage.removeItem('livesaas_reservation')
  if (!isJA()) {
    ElMessage.error({
      message: t('抱歉，当前直播内容暂不支持观看'),
      onClose: () => {
        window.location.href = '/'
      }
    })
    return
  }

  // debugger
  // 判断是否没有登录跳转登录 不是会员跳出会员
  if (showIfNeedMemberDialogForLive(showIfNeedMemberDialogForLiveOptions)) return
  const activityId = reserize()?.activityId
  if (activityId) {
    // {
    //   "code": "",
    //   "data": {
    //     "activityId": 0,
    //     "coverImage": "",
    //     "enablePeopleCount": 0,
    //     "liveTime": 0,
    //     "name": "",
    //     "pcBackImageUrl": "",
    //     "pcBackImageUrlDefault": "",
    //     "pcHeaderImageUrl": "",
    //     "reserveFlag": 0,
    //     "status": 0,
    //     "token": "",
    //     "uv": 0,
    //     "viewUrl": ""
    //   },
    //   "msg": "",
    //   "success": true
    // }
    const xx = {
      code: '0',
      msg: '操作成功',
      success: true,
      data: {
        activityId: '1772373774978072',
        name: '时光测试直播间2',
        coverImage: '//p1-live.byteimg.com/tos-cn-i-gjr78lqtd0/94f6b9aec2cc4d2fbdaeec8b92737fcb~tplv-gjr78lqtd0-z75.image',
        status: 2,
        enablePeopleCount: 1,
        uv: '19',
        liveTime: '1690537560',
        viewUrl: 'https://live.byteoc.com/1612/1622543',
        token: 'TFsNIs',
        reserveFlag: 0,
        pcHeaderImageUrl: '//p1-live.byteimg.com/tos-cn-i-gjr78lqtd0/02055e7331a7424ea9a5655e127a1d4a~tplv-gjr78lqtd0-z75.image',
        pcBackImageUrl: '//p6-live.byteimg.com/tos-cn-i-gjr78lqtd0/941b5d90f0140dbba08330705bdc8ff4.jpg~tplv-gjr78lqtd0-image.image',
        pcBackImageUrlDefault: 'https://p1-live.byteimg.com/tos-cn-i-gjr78lqtd0/17fb76a2b68c4186979ae24b372010d8~tplv-gjr78lqtd0-image.image'
      }
    }
    // 获取直播详情
    const res = await requestVideoGetActivityById({ activityId })
    resActivityDetail.value = res.data
    // 获取 token
    const resRequestVideoGetToken = await requestVideoGetToken({
      activityId, mode: ENUM_ACTIVITY_MODE.USE_CKB_USER
    })
    const mode2token = resRequestVideoGetToken.data
    resActivityDetail.value.token = mode2token
    console.log('resRequestVideoGetToken', resRequestVideoGetToken)
    console.log(requestVideoGetActivityById)
    console.log(999)
    console.log(resActivityDetail.value.pcBackImageUrl)
    if (!resActivityDetail.value.token) return
    initLive()

    const cardClick = async (params: { text: string; url: string; }) => {
      const index = (params.url ?? '').indexOf('/goods/')
      if (index === -1) return
      const goodsId = params.url.slice(index).replace('/goods/', '')
      const isB2B = useUser().systemSource === 2
      // 跳出到商品详情页面 这里暂停
      // webSDK.current?.emit('player.pause')
      // window.location.href = `/${isB2B ? 'b2b' : 'd2c'}/goods/${goodsId}?activityId=${activityId}`
      window.open(`/${isB2B ? 'b2b' : 'd2c'}/goods/${goodsId}?activityId=${activityId}`)
    }
    // 浮动卡片
    webSDK.current?.on('floatingCard.click', cardClick)
    // 卡片
    webSDK.current?.on('card.click', cardClick)
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      (!!resActivityDetail.value.token)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "page-live",
            style: _normalizeStyle(resActivityDetail.value.token ? { 'background-image': `url(${resActivityDetail.value.pcBackImageUrl})` } : {})
          }, [
            _createElementVNode("div", {
              class: "page-header",
              style: _normalizeStyle(resActivityDetail.value.token ? { 'background-image': `url(${resActivityDetail.value.pcHeaderImageUrl})` } : {})
            }, null, 4),
            _hoisted_3
          ], 4))
        : _createCommentVNode("", true)
    ])
  ], 64))
}
}

})